/*
 * @Description: 
 * @Date: 2020-07-27 11:25:02
 */
import dateFormat from '@/utils/dateFormat'
export const moneyFixed = (num) => {
  if (!isNaN(num)) {
    let n = (Number(num) / 100).toFixed(2)
    return n + '元'
  } else {
    return 0
  }
}
export const transMonth = (input) => {
  return dateFormat(input, 'MM-DD HH:mm')
}
export const transMin = (input) => {
  return dateFormat(input, 'HH:mm')
}
export const transMonths = (input) => {
  return dateFormat(input, 'YYYY-MM-DD')

}
export const transTime = (input) => {
  return dateFormat(input, 'YYYY-MM-DD HH:mm')

}
